import { render, staticRenderFns } from "./FontelloIconPage.vue?vue&type=template&id=c59ffe2a&scoped=true&"
import script from "./FontelloIconPage.vue?vue&type=script&lang=js&"
export * from "./FontelloIconPage.vue?vue&type=script&lang=js&"
import style0 from "./FontelloIconPage.vue?vue&type=style&index=0&id=c59ffe2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59ffe2a",
  null
  
)

export default component.exports